import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { IntlProvider } from 'react-intl'
import initLocalisation from './assets/util/localisation/initLocalisation';
import { StoreProvider } from './Store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const container = document.getElementById('root');
const localisation = initLocalisation()
console.log('-----Entory---');
ReactDOM.render(
  <BrowserRouter>
    <IntlProvider {...localisation}>
      <StoreProvider>
        <App />
      </StoreProvider>
    </IntlProvider>
  </BrowserRouter>,
  container
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register();
